@import '../../stylesheets/defaults'

// Only the Panel form has a host, so the host rule sizes that form alone. The React form has no
// host, so the modal element carries the width itself. Both read one custom property, which
// inherits through the shadow boundary, so a callsite overriding `--mp-confirm-width` moves both.
:host
  position absolute
  width var(--mp-confirm-width, 400px)

// A class rather than the `mp-modal` tag: outside a shadow root this stylesheet is injected into
// `document.head`, where a tag selector would resize every modal on the page.
.mp-confirm-modal
  width var(--mp-confirm-width, 400px)

.mp-confirm-container, .mp-confirm-container *
  box-sizing border-box

.mp-confirm-container
  display flex
  flex-direction column

  .mp-confirm-body
    display flex
    flex-direction row
    min-height 92px
    padding 24px 24px 0
    text-align left

    .mp-confirm-body-content
      width 100%

      .mp-confirm-description-newline
        white-space pre-line

        span
          display block
          padding-bottom 8px

  .mp-confirm-buttons
    display flex
    justify-content flex-end
    padding 24px

    .mp-button-root
      margin-left 8px

  .mp-confirm-mp-input
    margin-top 12px
    width 100%

.mp-confirm-info-banner-bottom
  margin-top 16px
